"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIProduceValueEvents = exports.ValueStatus = void 0;
var ValueStatus;
(function (ValueStatus) {
    ValueStatus["Pending"] = "pending";
    ValueStatus["Unavailable"] = "unavailable";
    ValueStatus["Ok"] = "ok";
    ValueStatus["Fault"] = "fault";
})(ValueStatus = exports.ValueStatus || (exports.ValueStatus = {}));
function isIProduceValueEvents(value) {
    if (typeof value.registerValueEventListener !== "function") {
        return false;
    }
    return true;
}
exports.isIProduceValueEvents = isIProduceValueEvents;
//# sourceMappingURL=IProduceValueEvents.js.map